module.exports = __webpack_public_path__ + "static/media/shadow.864a6c8c.png";